// material-ui
// import { useMediaQuery, useTheme } from "@mui/material";

import NavCard from "./NavCard";
import Navigation from "./Navigation";
import SimpleBar from "components/third-party/SimpleBar";
// project-imports
import { useSelector } from "store";
import useUserAuthInfo from "hooks/useAuthInfo";

// import Lottie from "lottie-react";
// import christmasTreeAnimation from "assets/video/christmas-tree-lottie.json";

// import { useSelector } from 'store';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const { token, clientid } = useUserAuthInfo();
  // const theme = useTheme();
  // const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"));

  const { drawerOpen } = useSelector((state) => state.menu);

  return (
    <SimpleBar
      sx={{
        "& .simplebar-content": {
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      <>
        <Navigation />
        {drawerOpen && <NavCard token={token} clientid={clientid} />}
        {/* {drawerOpen && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "auto",
              paddingBottom: "10px"
            }}
          >
            <Lottie
              animationData={christmasTreeAnimation}
              loop={true}
              style={{ width: 150, height: 150 }}
            />
          </div>
        )} */}
      </>
    </SimpleBar>
  );
};

export default DrawerContent;
